module.exports = __webpack_public_path__ + "static/media/antigua-beaches-55.87ae9d7f.jpg";